import { render, staticRenderFns } from "./ForRecord.vue?vue&type=template&id=9fc905bc&"
import script from "./ForRecord.vue?vue&type=script&lang=js&"
export * from "./ForRecord.vue?vue&type=script&lang=js&"
import style0 from "./ForRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports